(function () {
  'use strict';

  angular.module('ringbaPortal').component('concurrencySchedule', {
    bindings: {
      schedule: '<',
      tableCompact: '@',
      setHours: '=',
      onUpdate: '&',
      inputLabel: '@',
      inputTooltip: '@',
      isReadOnly: '<',
      hideLabel: '@',
      tableCustomClass: '@'
    },
    controller: ConcurrencyScheduleController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/concurrency-schedule/concurrency-schedule.view.html'
  });

  function ConcurrencyScheduleController(
    _,
    $q,
    $filter,
    hoursScheduleService
  ) {
    'ngInject';


    const vm = this;

    vm.hoursOfOperation = [];
    vm.daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    // Configure Time Selector
    vm.hstep = 1;
    vm.mstep = 1;
    vm.isMeridian = true;
    vm.showAdvancedHours = false;

    vm.toggleAdvancedHours = toggleAdvancedHours;
    vm.allCloseTimes = allCloseTimes;
    vm.allOpenTimes = allOpenTimes;
    vm.toggleSetHours = toggleSetHours;
    vm.hoursChanged = hoursChanged;
    vm.addBreak = addBreak;
    vm.removeBreak = removeBreak;
    vm.showAddBreakRow = showAddBreakRow;
    vm.toggleHours = toggleHours;
    vm.toggleMode = toggleMode;
    vm.checkDayTime = hoursScheduleService.checkDayTime;
    vm.isOpenAfterClosing = hoursScheduleService.isOpenAfterClosing;

    vm.$onChanges = onChanges;
    vm.$onInit = onInit;

    // Temporary store used when toggling between basic and advanced
    vm.storedHoursOfOperation = null;
    vm.storedObjectHoursOfOperation = null;
    vm.ignoreUpdate = false;

    vm.showAddBreak = false;

    function onInit() {
      if (typeof vm.isReadOnly === 'undefined' ) {
        vm.isReadOnly = false;
      }
      vm.concurrencyScheduleWarningTT = $filter('translate')('CONCURRENCY_SCHEDULE_WARNING_TT');
      _loadFromParentValues(vm.schedule);
    }

    function onChanges(changesObj) {
      if (vm.schedule && changesObj.schedule && (changesObj.schedule.previousValue === undefined || changesObj.schedule.isFirstChange())) {
        _loadFromParentValues(vm.schedule);
      }
    }

    function toggleSetHours() {
      if (vm.ignoreUpdate) {
        vm.ignoreUpdate = false;

        // This was necessary so the component can let the parent know when the schedule is active, but has been disabled.
        // Otherwise the parent wouldn't know when that happens. More specific this would happen when used on the payout hours
        if (vm.schedule && !vm.setHours) {
          vm.hoursOfOperation = null;
          vm.onUpdate(_getHoursInObjectForm());
        }
      } else {
        if (vm.setHours) {
          const openTime = { hour: 9, minute: 0 };
          const closeTime = { hour: 21, minute: 0 };
          _initializeHoursOfOperation(openTime, closeTime);
          vm.showAdvancedHours = false;
          vm.onUpdate(_getHoursInObjectForm());
        } else {
          vm.hoursOfOperation = null;
          vm.onUpdate(_getHoursInObjectForm());
        }
      }
    }

    function toggleAdvancedHours() {
      vm.showAdvancedHours = !vm.showAdvancedHours;
      if (!vm.showAdvancedHours) {
        vm.allCloseTimes();
        vm.allOpenTimes();
        _setBreakForAllDays();
        _allOpen(false);
        _allInverted(false);
        vm.onUpdate(_getHoursInObjectForm());
      }
    }

    function _areAllHoursTheSame() {
      return hoursScheduleService.isBasic(vm.hoursOfOperation);
    }


    function allCloseTimes() {
      _.forEach(vm.hoursOfOperation, function (hours) {
        hours.closeTime = vm.closeTime;
      });
      vm.onUpdate(_getHoursInObjectForm());
    }

    function allOpenTimes() {
      _.forEach(vm.hoursOfOperation, function (hours) {
        hours.openTime = vm.openTime;
      });
      vm.onUpdate(_getHoursInObjectForm());
    }

    function hoursChanged() {
      vm.onUpdate(_getHoursInObjectForm());
    }


    function addBreak(breakToAdd, advanced, index) {
      if (advanced) {
        vm.hoursOfOperation[index].breaks = vm.hoursOfOperation[index].breaks ? vm.hoursOfOperation[index].breaks : [];
        vm.hoursOfOperation[index].breaks.push(breakToAdd);
      } else {
        vm.breaksForAllDays = vm.breaksForAllDays ? vm.breaksForAllDays : [];
        vm.breaksForAllDays.push(breakToAdd);
        _setBreakForAllDays();
      }
      hoursChanged();
    }

    function removeBreak(breakToRemoveIndex, advanced, index) {
      if (advanced) {
        vm.hoursOfOperation[index].breaks.splice(breakToRemoveIndex, 1);
      } else {
        vm.breaksForAllDays.splice(breakToRemoveIndex, 1);
        _setBreakForAllDays();
      }
      hoursChanged();
    }

    function showAddBreakRow(show, advanced, index) {
      if (advanced) {
        vm.hoursOfOperation[index].showAddBreak = show;
      } else {
        vm.showAddBreak = show;
      }
    }

    function toggleHours() {
      vm.showHours = !vm.showHours;
    }

    function toggleMode() {
      vm.isMeridian = !vm.isMeridian;
    }

    function _setBreakForAllDays() {
      _.forEach(vm.hoursOfOperation, function (hours) {
        hours.breaks = angular.copy(vm.breaksForAllDays);
      });
    }

    function _allInverted(value) {
      _.forEach(vm.hoursOfOperation, function (hours) {
        hours.inverted = value;
      });
    }

    function _allOpen(value) {
      _.forEach(vm.hoursOfOperation, function (hours) {
        hours.isClosed = value;
      });
    }

    function _loadFromParentValues(schedule) {
      if (schedule) {
        _loadHoursOfOperation(schedule);
        _setHoursFromIndex(0);
        vm.showAdvancedHours = (vm.showAdvancedHours === true || !_areAllHoursTheSame());
        if (!vm.setHours) {
          vm.ignoreUpdate = true;
        }
        vm.setHours = true;
      } else if (vm.hideLabel) {
        const openTime = { hour: 9, minute: 0 };
        const closeTime = { hour: 21, minute: 0 };

        _initializeHoursOfOperation(openTime, closeTime);
        vm.showAdvancedHours = false;
        vm.onUpdate(_getHoursInObjectForm());
      } else {
        if (vm.setHours) {
          vm.ignoreUpdate = true;
        }
        vm.setHours = false;
      }
    }

    function _getHoursInObjectForm() {
      if (!vm.hoursOfOperation) {
        return { hoursOfOperation: null };
      } else {
        const rv = [];
        for (let index = 0; index < vm.hoursOfOperation.length; index++) {
          let openTime = {}, closeTime = {};
          if (vm.hoursOfOperation[index].openTime) {
            openTime = _parseTime(vm.hoursOfOperation[index].openTime);
          }

          if (vm.hoursOfOperation[index].closeTime) {
            closeTime = _parseTime(vm.hoursOfOperation[index].closeTime);
          }
          const inverted = vm.hoursOfOperation[index].inverted;

          const isClosed = vm.hoursOfOperation[index].isClosed;
          const breaks = vm.hoursOfOperation[index].breaks;


          rv.push({
            openTime: openTime,
            closeTime: closeTime,
            inverted: inverted,
            isClosed: isClosed,
            breaks: breaks
          });
        }
        return { hoursOfOperation: rv };
      }
    }

    function _setHoursFromIndex(index) {
      vm.openTime = vm.hoursOfOperation[index].openTime;
      vm.closeTime = vm.hoursOfOperation[index].closeTime;
      vm.breaksForAllDays = vm.hoursOfOperation[index].breaks;
    }

    function _initializeHoursOfOperation(openTime, closeTime) {
      _setTimes(openTime, closeTime);
      vm.hoursOfOperation = [];
      _.forEach(vm.daysOfWeek, function () {
        vm.hoursOfOperation.push({ isClosed: false, inverted: false, openTime: vm.openTime, closeTime: vm.closeTime });
      });
    }

    function _setTimes(openTime, closeTime) {
      vm.openTime = new Date();
      vm.openTime.setHours(openTime.hour);
      vm.openTime.setMinutes(openTime.minute);

      vm.closeTime = new Date();
      vm.closeTime.setHours(closeTime.hour);
      vm.closeTime.setMinutes(closeTime.minute);
    }

    // Loads schedule into ui format
    function _loadHoursOfOperation(data) {
      if (data) {
        vm.hoursOfOperation = [];
        _.forEach(data, function (day) {
          const openTime = new Date();
          openTime.setHours(day.openTime.hour);
          openTime.setMinutes(day.openTime.minute);
          openTime.setSeconds(0);
          openTime.setMilliseconds(0);


          const closeTime = new Date();
          closeTime.setHours(day.closeTime.hour);
          closeTime.setMinutes(day.closeTime.minute);
          closeTime.setSeconds(0);
          closeTime.setMilliseconds(0);
          vm.hoursOfOperation.push({
            openTime: new Date(openTime.getTime()),
            closeTime: new Date(closeTime.getTime()),
            inverted: day.inverted,
            isClosed: day.isClosed,
            breaks: day.breaks
          });

          vm.showBreaks = vm.showBreaks ||!!day.breaks;
        });
      } else {
        _initializeHoursOfOperation();
      }
    }

    function _parseTime(dateTime) {
      return {
        hour: dateTime.getHours(),
        minute: dateTime.getMinutes()
      };
    }
  }
})();
